import { MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { queryClient } from './queryClient';
import { router } from './router';
import { invetrakTheme } from './theme';
import { UpdateRequiredModal } from './UpdateRequiredModal';

import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
// After Mantine's own sheet, so the phone minimums win over its default control heights.
import './touchTargets.css';

export function App() {
  return (
    <MantineProvider theme={invetrakTheme} defaultColorScheme="light">
      <Notifications position="top-right" />
      {/* Outside the router on purpose: a required update has to appear on every screen, and the
          one it was missing from was Sign In — where, until now, there was no way to check for an
          update at all without logging in first. */}
      <UpdateRequiredModal />
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </MantineProvider>
  );
}
